import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import NewsManagement from './AdminSections/NewsManagement';
import UserManagement from './AdminSections/UserManagement';
import ContentManagement from './AdminSections/ContentManagement';
import FeedbackManagement from './AdminSections/FeedbackManagement';
import SystemSettings from './AdminSections/SystemSettings';
import './AdminPanel.css';

function AdminPanel() {
  const [currentSection, setCurrentSection] = useState('news');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const renderSection = () => {
    switch (currentSection) {
      case 'news':
        return <NewsManagement />;
      case 'users':
        return <UserManagement />;
      case 'content':
        return <ContentManagement />;
      case 'feedback':
        return <FeedbackManagement />;
      case 'settings':
        return <SystemSettings />;
      default:
        return <NewsManagement />;
    }
  };

  return (
    <div className="admin-panel-container">
      <AdminSidebar 
        currentSection={currentSection}
        setCurrentSection={setCurrentSection}
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
      />
      
      <div className={`admin-main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
        {renderSection()}
      </div>
    </div>
  );
}

export default AdminPanel;
